import { createContext, useContext, useState } from "react";

//create the context
const notificationContext = createContext(null);
//create the provider function component that wraps the app
const NotificationContext = (props) => (
  <notificationContext.Provider value={useNotificationContext()}>
    {props.children}
  </notificationContext.Provider>
);

export const useNotifications = () => useContext(notificationContext);

const useNotificationContext = () => {
  let [notifications, setNotifications] = useState([]);

  const pushNotification = (text, action = null) => {
    setNotifications([...notifications, { text, action }]);
  };

  return {
    notifications,
    pushNotification,
    setNotifications,
  };
};

export default NotificationContext;
